import { createContext } from 'react'

const TalksContext = createContext(null)
const QuestionsContext = createContext(null)

export { TalksContext, QuestionsContext }
